<nz-row [nzGutter]="10" nzJustify="space-between" nzAlign="middle">
  <nz-col>
    {{ inspectionInfo | inspectionTitle }}
  </nz-col>
  <nz-col *ngIf="score">
    <div class="score">
      <span class="label">
        {{ 'JUPITER.SCORE' | translate | lowercase }}
      </span>
      <span class="value">
        {{ score }}
      </span>
    </div>
  </nz-col>
</nz-row>
